<template>
    <a-modal :title="props.tableColumnsData.full_name + '_发票'" :confirmLoading="state.loading" centered
        :bodyStyle="{ padding: '20px' }" :width="1000" :open="true" @cancel="cancel">
        <template #footer>
            <a-button @click="cancel">取消</a-button>
            <a-popconfirm title="是否确定？" @confirm="onFormSubmit">
                <a-button :loading="state.loading" type="primary">确定申请发票</a-button>
            </a-popconfirm>
        </template>
        <!-- 申请发票记录 -->
        <a-table size="small" :loading="state.loading" style="margin-bottom: 30px" :columns="columns"
            :data-source="dataSource" :pagination="false"
            :row-selection="{ selectedRowKeys: state.selectedRowKeys, type: 'radio', onChange: onSelectChange }"
            rowKey="id">
            <template #bodyCell="{ column, record, index, text }">
                <template v-if="column.dataIndex === 'action'"> {{ record.action_name }} </template>
            </template>
        </a-table>
        <!-- 表单提交发票需要的内容 -->
        <a-form ref="ruleForm" :rules="rules" :model="formState" v-bind="formLayout" scrollToFirstError="true">
            <a-form-item label="购买方名称" name="full_name" required>
                <a-input placeholder="" v-model:value="formState.full_name" @blur="() => {
                    formState.full_name = formState.full_name
                        .replace(/([\u4e00-\u9fa5])\(/g, '$1（')
                        .replace(/\)([\u4e00-\u9fa5])/g, '）$1');
                }"></a-input>
            </a-form-item>
            <a-form-item label="统一社会信用代码" name="social_credit_code" required>
                <a-input placeholder="" v-model:value="formState.social_credit_code"></a-input>
            </a-form-item>
            <a-form-item label="开票税目" required>
                <a-radio-group v-model:value="taxtype">
                    <a-radio :value="1" @click="() => handleRadioChange(1)">入驻服务费</a-radio>
                    <a-radio :value="2" @click="() => handleRadioChange(2)" v-if="state.push_system == 2">房租</a-radio>
                </a-radio-group>
            </a-form-item>
            <a-form-item label="此单推荐零售价" name="recommended_price">
                <a-input placeholder="" v-model:value="formState.recommended_price" prefix="￥" suffix="元"
                    style="width: 160px" disabled>
                    <template #addonAfter>
                        <a-tooltip title="此数据来自系统推荐零售价">
                            <QuestionCircleOutlined />
                        </a-tooltip>
                    </template>
                </a-input>
                <span style="color: #999; font-size: 12px; margin-left: 8px;">（系统推荐零售价，不可修改）</span>
            </a-form-item>
            <a-form-item label="发票备注" name="invoice_remark">
                <a-textarea placeholder="" v-model:value="formState.invoice_remark" />
                西安税务老师一般不要发票，如果需要，入驻服务费即可，请做好解释工作！
            </a-form-item>
            <a-form-item label="开票金额" name="invoice_amount" required>
                <a-input placeholder="" v-model:value="formState.invoice_amount" prefix="￥" suffix="元"
                    style="width: 140px" disabled></a-input>
                <span style="color: #999; font-size: 12px; margin-left: 8px;">（流水金额，不可修改）</span>
            </a-form-item>
            <!-- 管理费告知区域 -->
            <a-form-item label="管理费说明" v-if="formState.show_cha">
                <div style="background: #fff7e6; padding: 14px 16px; border-radius: 4px; border: 1px solid #ffd591;">
                    <div style="display: flex; justify-content: space-between; padding: 4px 0;">
                        <span style="color: #666;">推荐零售价：</span>
                        <span>￥{{ formState.recommended_price }} 元</span>
                    </div>
                    <div
                        style="display: flex; justify-content: space-between; padding: 4px 0; border-bottom: 1px dashed #f0f0f0;">
                        <span style="color: #666;">开票金额（流水）：</span>
                        <span>￥{{ formState.invoice_amount }} 元</span>
                    </div>
                    <div
                        style="display: flex; justify-content: space-between; padding: 8px 0; color: #ff4d4f; font-weight: bold;">
                        <span>超额部分：</span>
                        <span>￥{{ formState.cha }} 元</span>
                    </div>
                    <div style="display: flex; justify-content: space-between; padding: 4px 0; color: #faad14;">
                        <span>管理费率：</span>
                        <span>{{ taxtype === 1 ? '3%' : '6%' }}</span>
                    </div>
                    <div
                        style="display: flex; justify-content: space-between; padding: 4px 0; color: #faad14; font-weight: bold; border-bottom: 1px dashed #f0f0f0;">
                        <span>产生管理费：</span>
                        <span>￥{{ formState.management_fee }} 元</span>
                    </div>
                    <div
                        style="display: flex; justify-content: space-between; padding: 8px 0 4px 0; color: #1890ff; font-weight: bold; font-size: 15px;">
                        <span>实际开票金额：</span>
                        <span>￥{{ formState.invoice_amount }} 元</span>
                    </div>
                    <div
                        style="margin-top: 8px; color: #999; font-size: 12px; border-top: 1px solid #f0f0f0; padding-top: 8px;">
                        <div>计算公式：管理费 = (开票金额 - 推荐零售价) × 管理费率</div>
                        <div style="color: #faad14;">注：管理费仅为告知，实际开票金额仍为流水金额</div>
                    </div>
                </div>
            </a-form-item>
            <!-- 无超额时提示 -->
            <a-form-item label="管理费说明" v-else-if="formState.invoice_amount > 0">
                <div
                    style="background: #f6ffed; padding: 10px 16px; border-radius: 4px; border: 1px solid #b7eb8f; color: #52c41a;">
                    <CheckCircleOutlined /> 当前开票金额未超过推荐零售价，无需收取管理费
                </div>
            </a-form-item>
            <a-form-item label="申请备注" name="remark">
                <a-textarea placeholder="" v-model:value="formState.remark" />
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<script lang="ts" setup>
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { reactive, onMounted, ref, watch } from 'vue'
import dayjs from 'dayjs'
import Upload from '@/components/base/Upload.vue'
import { QuestionCircleOutlined, InfoCircleOutlined, CheckCircleOutlined } from '@ant-design/icons-vue'

const emit = defineEmits(['cancel', 'ok'])
const props = defineProps({
    tableColumnsData: {
        type: Object,
        default: () => { }
    }
})

const state = reactive<any>({
    loading: false,
    selectedRowKeys: [],
    selectedRecord: {},
    platform_name: '',
    platform_social_credit_code: '',
    push_system: 1,
    lastaddfield: ''
})

const taxtype = ref<number | undefined>()
const dataSource = ref([])

const columns: Array<Object> = [
    {
        title: '订单号',
        dataIndex: 'order_number',
        width: 250
    },
    {
        title: '流水金额',
        dataIndex: 'actually_paid_money',
        width: 200
    },
    {
        title: '状态',
        dataIndex: 'status',
        width: 200
    },
    {
        title: '类型',
        dataIndex: 'action',
        width: 200
    },
    {
        title: '付款时间',
        dataIndex: 'created_at',
        width: 200
    }
]

// 管理费率映射
const MANAGEMENT_RATE = {
    1: 0.03, // 入驻服务费 3%
    2: 0.06  // 房租 6%
}

onMounted(() => {
    loadData()
})

// 监听税目变化，重新计算管理费
watch(taxtype, () => {
    checkAmount()
    refreshRemark()
})

const loadData = () => {
    state.loading = true
    let requestParam = {
        url: '/admin/v1/customerInvoiceRecord',
        method: 'post',
        data: { customer_id: props.tableColumnsData.id }
    }
    baseService(requestParam)
        .then((res: any) => {
            state.loading = false
            dataSource.value = res.data.list
            formState.full_name = res.data.full_name
            formState.social_credit_code = res.data.social_credit_code
            state.platform_name = res.data.platform_name
            state.platform_social_credit_code = res.data.platform_social_credit_code
            state.push_system = res.data.push_system
            checkAmount()
        })
        .catch((res) => {
            state.loading = false
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('查询失败')
            }
        })
}

// 统一刷新备注
const refreshRemark = () => {
    const record = state.selectedRecord
    if (!record?.action) {
        formState.invoice_remark = ''
        return
    }
    if (record.action === 'custRenewal' || record.action === 'custRegister') {
        formState.invoice_remark = record.full_name +
            dayjs(record.before_enter_endtime, 'YYYY年MM月DD日').format('YYYY年MM月') +
            '~' +
            dayjs(record.alter_enter_endtime, 'YYYY年MM月DD日').format('YYYY年MM月') +
            state.lastaddfield
    } else {
        formState.invoice_remark = ''
    }
}

const handleRadioChange = (val: number) => {
    taxtype.value = val
    state.lastaddfield = val === 1 ? '入驻服务费' : '房租'
    refreshRemark()
}

// 选中表格行
const onSelectChange = (selectedRowKeys: any[], val) => {
    state.selectedRowKeys = selectedRowKeys
    state.selectedRecord = val[0]
    // 开票金额 = 流水金额
    formState.invoice_amount = val[0].actually_paid_money

    // TODO: 从数据库获取该订单的推荐零售价
    // 模拟数据：默认350元
    formState.recommended_price = 350

    taxtype.value = undefined
    state.lastaddfield = ''

    refreshRemark()
    checkAmount()
}

// 表单配置
const formLayout = {
    labelCol: {
        xs: { span: 7 },
        sm: { span: 7 }
    },
    wrapperCol: {
        xs: { span: 14 },
        sm: { span: 14 }
    }
}
const ruleForm = ref()
const rules = []
const formState = reactive({
    full_name: '',
    social_credit_code: '',
    fee_standard: 1,
    recommended_price: 350,    // 推荐零售价（默认350，后续从数据库获取）
    invoice_amount: 0,         // 开票金额 = 流水金额，不可修改
    invoice_remark: '',
    show_cha: false,           // 是否产生管理费（超额）
    cha: 0,                    // 超额部分 = 开票金额 - 推荐零售价
    management_fee: 0,         // 管理费
    attachment: [],
    remark: '',
    order_id: 0,
    customer_id: 0
})

const checkAmount = () => {
    let invoiceAmount = Number(formState.invoice_amount) || 0
    let recommendedPrice = Number(formState.recommended_price) || 0

    // 计算超额部分 = 开票金额 - 推荐零售价
    if (invoiceAmount > recommendedPrice) {
        formState.show_cha = true
        formState.cha = Number((invoiceAmount - recommendedPrice).toFixed(2))

        // 计算管理费 = 超额部分 × 管理费率
        const rate = taxtype.value ? MANAGEMENT_RATE[taxtype.value as keyof typeof MANAGEMENT_RATE] || 0 : 0
        formState.management_fee = Number((formState.cha * rate).toFixed(2))
    } else {
        formState.show_cha = false
        formState.cha = 0
        formState.management_fee = 0
    }
}

// 提交表单
const onFormSubmit = () => {
    ruleForm.value
        .validate()
        .then(() => {
            if (!state.selectedRecord.id) {
                message.error('请选择开票订单')
                return
            }
            if (!taxtype.value) {
                message.error('请选择开票税目')
                return
            }
            if (formState.invoice_amount <= 0) {
                message.error('开票金额无效')
                return
            }
            state.loading = true
            formState.order_id = state.selectedRecord.id
            formState.customer_id = props.tableColumnsData.id

            // 构建提交数据（包含管理费信息用于记录）
            let submitData = {
                ...formState,
                recommended_price: formState.recommended_price,
                cha: formState.cha,
                management_fee: formState.management_fee,
                tax_type: taxtype.value,
                tax_rate: MANAGEMENT_RATE[taxtype.value as keyof typeof MANAGEMENT_RATE] || 0,
                show_cha: formState.show_cha
            }

            let requestParam = {
                url: '/admin/v1/customerInvoice',
                method: 'post',
                data: submitData
            }
            baseService(requestParam)
                .then(() => {
                    message.success('提交成功')
                    cancel()
                })
                .catch((res) => {
                    state.loading = false
                    message.error(res.msg || '申请失败')
                })
        })
        .catch(() => { })
}

const cancel = () => {
    emit('cancel')
}
</script>

<style lang="scss" scoped></style>
